import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { useEffect, useState } from 'react';

dayjs.extend(duration);

export interface CustomTimerProps {
  /** ISO string reprezentující počáteční čas */
  startTime: string;
}

/**
 * Komponenta pro zobrazení uběhnutého času od zadaného počátečního času.
 * Formát: MM:SS pokud je čas < 1 hodina, jinak HH:MM:SS
 */
export const CustomTimer = ({ startTime }: CustomTimerProps) => {
  const [elapsedTime, setElapsedTime] = useState<string>('');

  useEffect(() => {
    const calculateElapsed = () => {
      const start = dayjs(startTime);
      const now = dayjs();
      const diff = now.diff(start);

      if (diff < 0) {
        setElapsedTime('00:00');
        return;
      }

      const dur = dayjs.duration(diff);
      const hours = Math.floor(dur.asHours());
      const minutes = dur.minutes();
      const seconds = dur.seconds();

      if (hours > 0) {
        // Formát HH:MM:SS
        setElapsedTime(
          `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds
            .toString()
            .padStart(2, '0')}`
        );
      } else {
        // Formát MM:SS
        setElapsedTime(
          `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
        );
      }
    };

    // Vypočítat ihned při mount
    calculateElapsed();

    // Aktualizovat každou sekundu
    const interval = setInterval(calculateElapsed, 1000);

    return () => clearInterval(interval);
  }, [startTime]);

  return <span className="CustomTimer">{elapsedTime}</span>;
};

export default CustomTimer;
